(function () {
    'use strict';

    angular.module("imApp").factory("p2SubscriptionService", ['$ihttp', function ($ihttp) {
        let service = {
            getSubscription: function (parms) {
                return $ihttp.post({
                    method: 1179,
                    parameters: parms || {}
                });
            },
            listSubscriptions: function (parms) {
                return $ihttp.post({
                    method: 79,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
